import Basic from './basic.vue';
import MobBasic from '../v1/mob-basic.vue';

export const componentMap = {
	basic: Basic,
	'mob-basic': MobBasic
};
